import React, { useState } from "react";
import "./Nav.css";
import Logo from "../../Portfolio Asset/Hephzibah Designs.png";
import { Link } from "react-router-dom";
import {
  githubGrey,
  twitterGrey,
  linkedinGrey,
} from "../../Portfolio Asset/exportAsset";

import { motion } from "framer-motion";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";

const Nav = () => {
  const [toggle, setToggle] = useState(false);
  const [activeNav, setActiveNav] = useState("/");

  return (
    <motion.div
      className="app__nav"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.8, ease: [0, 0.71, 0.2, 1.01] }}
    >
      <div className="app__nav-logo">
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>

      <div className="app__nav-right">
        <ui className="app__nav-links">
          <li className="nav-links">
            <Link
              to="/"
              className={activeNav === "/" ? "activeNav" : ""}
              onClick={() => setActiveNav("/")}
            >
              Home
            </Link>
          </li>
          <li className="nav-links">
            <Link
              to="/about"
              className={activeNav === "/about" ? "activeNav" : ""}
              onClick={() => setActiveNav("/about")}
            >
              About
            </Link>
          </li>
          <li className="nav-links">
            <Link
              to="/tech-stack"
              className={activeNav === "/tech-stack" ? "activeNav" : ""}
              onClick={() => setActiveNav("/tech-stack")}
            >
              Tech stack
            </Link>
          </li>
          <li className="nav-links">
            <Link
              to="/project"
              className={activeNav === "/project" ? "activeNav" : ""}
              onClick={() => setActiveNav("/project")}
            >
              Project
            </Link>
          </li>
          <li className="nav-links">
            <Link
              to="/contact"
              className={activeNav === "/contact" ? "activeNav" : ""}
              onClick={() => setActiveNav("/contact")}
            >
              Contact
            </Link>
          </li>

          <li className="nav-links">
            <Link
              to="/AYENI_PAUL_RESUME_2026.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              My Resume
            </Link>
          </li>
        </ui>

        <div className="app__nav-icon-links">
          <Link
            to="https://github.com/HephzibahDesigns"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={githubGrey} alt="github icon" />
          </Link>
          <Link
            to="https://twitter.com/PaulBolu15"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitterGrey} alt="github icon" />
          </Link>
          <Link
            to="https://www.linkedin.com/in/ayeni-paul-4b708b1a9/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedinGrey} alt="github icon" />
          </Link>
        </div>
      </div>

      {/* Mobile Menu*/}

      <div className="app__nav-mobileMenu scale-up-center">
        {toggle ? (
          <IoMdClose size={27} color="fff" onClick={() => setToggle(false)} />
        ) : (
          <GiHamburgerMenu
            size={27}
            color="fff"
            onClick={() => setToggle(true)}
          />
        )}

        {toggle && (
          <div className="app__nav-mobileMenu-container scale-up-center">
            <ui
              className="app__nav-mobileMenu-links"
              onClick={() => setToggle(!toggle)}
            >
              <li className="nav-links">
                <Link to="/">Home</Link>
              </li>
              <li className="nav-links">
                <Link to="/about">About</Link>
              </li>
              <li className="nav-links">
                <Link to="/tech-stack">Tech stack</Link>
              </li>
              <li className="nav-links">
                <Link to="/project">Project</Link>
              </li>
              <li className="nav-links">
                <Link to="/contact">Contact</Link>
              </li>
              <li className="nav-links">
                <Link
                  to="/AYENI_PAUL_RESUME_2026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  My Resume
                </Link>
              </li>
            </ui>

            <div
              className="app__nav-mobileMenu-icon-links"
              onClick={() => setToggle(!toggle)}
            >
              <Link
                to="https://github.com/HephzibahDesigns"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={githubGrey} alt="github icon" />
              </Link>
              <Link
                to="https://twitter.com/PaulBolu15"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitterGrey} alt="github icon" />
              </Link>
              <Link
                to="https://www.linkedin.com/in/ayeni-paul-4b708b1a9/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinGrey} alt="github icon" />
              </Link>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default Nav;
